<template>
  <b-link :to="backRoute" class="text-decoration-none" v-text="$t(linkText || `productConfigBackLink.${backRouteName}`)" />
</template>

<script>
import { ProductRedirectMixins } from '@/mixins/redirect';

export default {
  name: 'ProductConfigBackLink',
  mixins: [ProductRedirectMixins],
  props: {
    petId: {
      type: String,
      default: null,
    },
    productType: {
      type: String,
      required: true,
      validator: (value) => ['Tag', 'Collar', 'Leash', 'Essentials', 'WalletCard'].includes(value),
    },
    linkText: {
      type: String,
      default: null,
    },
  },
  computed: {
    backRouteName() {
      if (this.determineRedirectRoute) {
        return this.determineRedirectRoute;
      }
      if (this.petId) {
        return 'StoreForPet';
      }
      switch (this.productType) {
        case 'Tag':
          return 'TagStore';
        case 'Collar':
          return 'CollarStore';
        case 'Leash':
          return 'LeashStore';
        case 'Essentials':
          return 'EssentialsStore';
        case 'WalletCard':
          return 'WalletCardStore';
        default:
          return 'Store';
      }
    },
    backRoute() {
      return {
        name: this.backRouteName,
        params: {
          petId: this.petId,
        },
        // Filter redirect_path from query
        query: Object.keys(this.$route.query)
          .filter((key) => key !== 'redirect_path')
          .reduce((obj, key) => {
            obj[key] = this.$route.query[key];
            return obj;
          }, {}),
      };
    },
  },
};
</script>

<style scoped></style>
